import type { Workbench } from '@minglun/domain';

/**
 * The packaged seed is the release floor. A cloud catalog may override it
 * within the same release, but an older cloud workspace must never mask a
 * newer catalog shipped by a hot update.
 */
export function selectPublishedCatalog(seed: Workbench, published?: Workbench): Workbench {
  if (!published) return seed;
  const releaseComparison = compareReleaseVersion(published.version, seed.version);
  if (releaseComparison > 0) return published;
  if (releaseComparison < 0) return seed;
  return published;
}

function compareReleaseVersion(left: string, right: string): number {
  if (left === right) return 0;
  const leftParts = releaseVersionParts(left);
  const rightParts = releaseVersionParts(right);
  if (!leftParts || !rightParts) return 0;
  const length = Math.max(leftParts.length, rightParts.length);
  for (let index = 0; index < length; index += 1) {
    const difference = (leftParts[index] ?? 0) - (rightParts[index] ?? 0);
    if (difference !== 0) return Math.sign(difference);
  }
  return 0;
}

function releaseVersionParts(version: string): number[] | undefined {
  const match = /^apk-(\d+(?:\.\d+)*)-(\d+)-(\d{4})\.(\d{2})\.(\d{2})\.(\d+)$/.exec(version.trim());
  if (!match) return undefined;
  return [
    ...match[1]!.split('.').map(Number),
    Number(match[2]),
    Number(match[3]),
    Number(match[4]),
    Number(match[5]),
    Number(match[6]),
  ];
}
